import React from 'react';
import classnames from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import AppModal from '@/components/AppModal/AppModal';
import TheButton from '@/components/school-management/TheButton/TheButton';
import AppLoaderCircle from '@/components/AppLoaderCircle';
import UsersTable from '@/admin/components/UsersTable/UsersTable';
import { UserData } from '@/school-management/types/user-data';
import classNames from './styles.module.scss';

interface ClassUsersTableModalProps {
  show: boolean;
  addUsersToNewGroup: boolean;
  usersData: UserData[];
  setUsersData: React.Dispatch<React.SetStateAction<UserData[]>>;
  disableSubmitButton: boolean;
  setDisableSubmitButton: React.Dispatch<React.SetStateAction<boolean>>;
  showNewUserInput: boolean;
  setShowNewUserInput: React.Dispatch<React.SetStateAction<boolean>>;
  isCsvSending: boolean;
  onBack: () => void;
  onSubmit: () => void;
  isTeacher?: boolean;
  usersInClass?: number;
}

const ClassUsersTableModal: React.FC<ClassUsersTableModalProps> = ({
  show,
  addUsersToNewGroup,
  usersData,
  setUsersData,
  disableSubmitButton,
  setDisableSubmitButton,
  showNewUserInput,
  setShowNewUserInput,
  isCsvSending,
  onBack,
  onSubmit,
  isTeacher,
  usersInClass = 0,
}) => {
  const { t } = useAdminTranslation();

  if (!show) return null;

  return (
    <AppModal show={show} type='fade'>
      <div className={classnames(classNames.modal, classNames.usersDataModal)}>
        <div className={classNames.usersTableModalHeader}>
          <h2>
            {addUsersToNewGroup
              ? isTeacher
                ? t('settings.add_teachers.invite_teachers')
                : t('settings.add_students.invite_students')
              : isTeacher
                ? t('settings.add_teachers.enroll_teachers')
                : t('settings.add_students.enroll_students')}
          </h2>
          <span className={classNames.description}>
            {isTeacher
              ? t('settings.add_teachers.create_teachers')
              : t('settings.add_students.create_students')}
          </span>
        </div>
        <UsersTable
          usersData={usersData}
          setUsersData={setUsersData}
          allowActions={true}
          allowNewRows={true}
          disableSubmitButton={disableSubmitButton}
          setDisableSubmitButton={setDisableSubmitButton}
          showNewUserInput={showNewUserInput}
          setShowNewUserInput={setShowNewUserInput}
          isModal={true}
          usersInClass={usersInClass}
          isTeacher={isTeacher}
        />
        {isCsvSending ? (
          <div className={classNames.loader}>
            <AppLoaderCircle />
          </div>
        ) : (
          <div className={classNames.buttons}>
            <TheButton
              className={classNames.cancelBtn}
              text={t('back')}
              plain
              emitOnClick={onBack}
            />
            <TheButton
              className={classNames.sendBtn}
              text={
                isTeacher
                  ? t('settings.add_teachers.enroll_teachers')
                  : t('settings.add_students.enroll_students')
              }
              type='submit'
              shouldRecolor={false}
              disabled={!usersData.length || disableSubmitButton || showNewUserInput}
              emitOnClick={onSubmit}
            />
          </div>
        )}
      </div>
    </AppModal>
  );
};

export default ClassUsersTableModal;
